module.exports = __webpack_public_path__ + "distribution/img/ico2.1f23abac.png";